var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{attrs:{"fields":_vm.fields,"show_per_page":false,"auto_start":false,"table_store":"mailer/archived_stats/detailed"},scopedSlots:_vm._u([{key:"body",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-inline-block text-truncate",staticStyle:{"max-width":"350px"}},[_vm._v(" "+_vm._s(item.body)+" ")])]}},{key:"state",fn:function(ref){
var value = ref.formatted;
return [_c('status-badge',{attrs:{"value":value}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }